import Vue from "vue";
import VueRouter from "vue-router";
import store from "@/store/index";
import { webRoutes } from "./webRouter";
import { getStorage } from "@/utils";
import { backRoutes } from "./backstageRouter";
import { message } from "ant-design-vue";
Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    redirect: "/index",
  },
  {
    path: "/home",
    name: "Home",
    component: () => import("@/views/Home"),
    meta: {
      title: "首页",
    },
    children: [...webRoutes, ...backRoutes],
  },
  {
    path: "/login",
    name: "Login",
    component: () => import("@/views/Login"),
    meta: {
      title: "登录",
    },
  },
  {
    path: "/patentAtlas",
    name: "patentAtlas",
    component: () => import("@/views/PatentAtlas"),
    meta: {
      title: "本校专利图谱",
    },
  },
];

// 解决ElementUI导航栏中的vue-router在3.0版本以上重复点菜单报错问题
const originalPush = VueRouter.prototype.push;
VueRouter.prototype.push = function push(location) {
  return originalPush.call(this, location).catch((err) => err);
};

const router = new VueRouter({
  // mode: 'hash',
  base: process.env.BASE_URL,
  scrollBehavior: () => ({
    y: 0,
  }),
  routes,
});

// 处理路由跳转后的，顶部菜单栏操作
router.beforeEach((to, from, next) => {
  const {
    meta,
    fullPath,
    // name,
    // query
  } = to;
  const selectedKeys = meta && meta.title ? meta.title.split(",") : [];
  let token = getStorage("token", 0);
  let role = getStorage("role", 0);

  const roleBlackList = ["common", "youke"];

  if (!token && to.path.includes("back")) {
    message.warning("请先登录");

    next("/home");
  }

  if (roleBlackList.includes(role) && to.path.includes("back")) {
    message.warning("当前账号无权限访问后台");
    next("/home");
  }
  // if(!checkRolePower(selectedKeys[0])) return  // 当前菜单不可跳

  const routerUpdateParams = {
    routerPath: fullPath,
    selectedKeys,
  };
  store.commit("headerMenu/updateMenuItemStatus", routerUpdateParams);
  // 处理滚动条回滚到顶部
  const domWrp = document.getElementsByClassName("home-wrap");
  if (domWrp.length > 0) {
    domWrp[0].scrollTop = 0;
  }
  next();
});

export default router;
